// extracted by mini-css-extract-plugin
export default {"technologies":"technologies_technologies__vRGHn"};